export enum VatNumberEnum {
    FINAL_CUSTOMER_VAT_NUMBER = 999999990
}
